import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  INITIALIZE_PAYMENT,
  REGISTER_TRANSACTION,
  VERIFY_PAYSTACK,
} from "./actionTypes";

import {
  initPaymentSuccess,
  initPaymentError,
  regTransactionSuccess,
  regTransactionError,
  verifyPaystackSuccess,
  verifyPaystackError,
  clearTransRef,
} from "./actions";

import { createPlan } from "../actions";

import {
  clearNewPlan,
  payWithCard,
  planAction,
  updatePlan,
} from "../plan/actions";

import {
  initializePaymentService,
  registerTransService,
  verifyPaymentService,
} from "../../services/paystackPayServices";

import toast from "react-hot-toast";

function* initPayment({ payload: { formData } }) {
  try {
    const response = yield call(initializePaymentService, formData);
    yield put(initPaymentSuccess(response.data));
    window.open(response.data);
  } catch (error) {
    yield put(initPaymentError(error?.response?.data));
  }
}

function* verifyPaystack({
  payload: {
    paymentGateway,
    transactionRef,
    dispatch,
    form,
    setShow,
    setDebitPopup,
    action,
  },
}) {
  try {
    const response = yield call(
      verifyPaymentService,
      paymentGateway,
      transactionRef
    );
    yield put(verifyPaystackSuccess(response.data));
    dispatch(clearTransRef());
    if (response) {
      if (action === "TOP_UP") {
        dispatch(planAction(form, setShow, null, dispatch, setDebitPopup));
      } else if (action === "PLAN_CREATION") {
        dispatch(
          updatePlan(
            transactionRef,
            form,
            form?.planId,
            null,
            "createPlan",
            setShow,
            setDebitPopup
          )
        );
        dispatch(clearNewPlan());
      } else if (action === "PAY_WITH_CARD") {
        dispatch(payWithCard(form, setShow, null, transactionRef));
      } else {
        dispatch(createPlan(form, setShow));
      }
    }
  } catch (error) {
    yield put(verifyPaystackError(error?.response?.data));
    if (error?.response?.data?.message) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
      });
    }
  }
}

function* regTransaction({ payload: { formData, setDebitPopup, isTopup } }) {
  try {
    const response = yield call(registerTransService, formData);
    yield put(regTransactionSuccess(response.data));
    // if (response && isTopup) {
    //   setDebitPopup(true);
    // }
  } catch (error) {
    yield put(regTransactionError(error?.response?.data));
    if (error?.response?.data?.message) {
      toast.error(error?.response?.data?.message, { position: "top-right" });
    }
  }
}

export function* watchInitPayment() {
  yield takeEvery(INITIALIZE_PAYMENT, initPayment);
}

export function* watchVerifyPaystack() {
  yield takeEvery(VERIFY_PAYSTACK, verifyPaystack);
}

export function* watchRegTransaction() {
  yield takeEvery(REGISTER_TRANSACTION, regTransaction);
}

function* PaystackSaga() {
  yield all([
    fork(watchInitPayment),
    fork(watchVerifyPaystack),
    fork(watchRegTransaction),
  ]);
}

export default PaystackSaga;
